"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeixinAuthApi = void 0;
var ajax_1 = __importDefault(require("../ajax"));
var WeixinAuthApi = /** @class */ (function () {
    function WeixinAuthApi(basePath) {
        var _this = this;
        this.$basePath = '/wxopen/v1'.replace(/\/$/, '');
        /**
         *
         * @summary 微信 公众号授权-获取token
         * @param params ParamswxpublicGetUserInfoGet
      
         * @param opt ajax config
         * @returns models.MiniAuthorizerAccessTokenSafe
         */
        this.wxpublicGetUserInfoGet = function (params) {
            var path = '/wxpublic/getUserInfo';
            var url = _this.$basePath + path;
            var p = {};
            p.query = {};
            if ('companyId' in params)
                p.query.companyId = params.companyId;
            ajax_1.default.check(params.companyId, 'companyId');
            if ('code' in params)
                p.query.code = params.code;
            ajax_1.default.check(params.code, 'code');
            if ('state' in params)
                p.query.state = params.state;
            ajax_1.default.check(params.state, 'state');
            if ('appId' in params)
                p.query.appId = params.appId;
            ajax_1.default.check(params.appId, 'appId');
            return ajax_1.default.ajax(__assign({ method: 'GET', url: url }, p));
        };
        if (basePath !== undefined) {
            this.$basePath = basePath.replace(/\/$/, '');
        }
    }
    return WeixinAuthApi;
}());
exports.WeixinAuthApi = WeixinAuthApi;
exports.default = new WeixinAuthApi();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2VpeGluQXV0aEFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hcGkvV2VpeGluQXV0aEFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGlEQUEyQjtBQXNCM0I7SUFHRSx1QkFBbUIsUUFBaUI7UUFBcEMsaUJBSUM7UUFOUyxjQUFTLEdBQUcsWUFBWSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFPdEQ7Ozs7Ozs7V0FPRztRQUNJLDJCQUFzQixHQUFHLFVBQzlCLE1BQW9DO1lBRXBDLElBQU0sSUFBSSxHQUFHLHVCQUF1QixDQUFDO1lBQ3JDLElBQU0sR0FBRyxHQUFHLEtBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDO1lBQ2xDLElBQU0sQ0FBQyxHQUFRLEVBQUUsQ0FBQztZQUNsQixDQUFDLENBQUMsS0FBSyxHQUFHLEVBQUUsQ0FBQztZQUNiLElBQUksV0FBVyxJQUFJLE1BQU07Z0JBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxTQUFTLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQztZQUNoRSxjQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxTQUFTLEVBQUUsV0FBVyxDQUFDLENBQUM7WUFDMUMsSUFBSSxNQUFNLElBQUksTUFBTTtnQkFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDO1lBQ2pELGNBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztZQUNoQyxJQUFJLE9BQU8sSUFBSSxNQUFNO2dCQUFFLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUM7WUFDcEQsY0FBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFDO1lBQ2xDLElBQUksT0FBTyxJQUFJLE1BQU07Z0JBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQztZQUNwRCxjQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDbEMsT0FBTyxjQUFJLENBQUMsSUFBSSxZQUNkLE1BQU0sRUFBRSxLQUFLLEVBQ2IsR0FBRyxLQUFBLElBQ0EsQ0FBQyxFQUNKLENBQUM7UUFDTCxDQUFDLENBQUE7UUFoQ0MsSUFBSSxRQUFRLEtBQUssU0FBUyxFQUFFO1lBQzFCLElBQUksQ0FBQyxTQUFTLEdBQUcsUUFBUSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7U0FDOUM7SUFDSCxDQUFDO0lBOEJILG9CQUFDO0FBQUQsQ0FBQyxBQXJDRCxJQXFDQztBQXJDWSxzQ0FBYTtBQXVDMUIsa0JBQWUsSUFBSSxhQUFhLEVBQUUsQ0FBQSJ9